export default __webpack_public_path__ + "static/media/new_patient_smile.a3b78e05.svg";